import * as React from "react";
import {
  DASHBOARD,
  MILESTONE,
  USERS,
} from "icons";
import { Outlet } from "react-router-dom";
import {
  Sidebar,
  SidebarContent,
  SidebarGroup,
  SidebarHeader,
  SidebarMenu,
  SidebarProvider,
  SidebarRail,
} from "ui/components/sidebar";
import Loader from "@/components/loader";
import { NavItem } from "@/components/nav/item";
import { NavItemWithBadge } from "@/components/nav/nav-item-with-badge";
import { OpeningProvider, useOpening } from "./context";

export default function OpeningsLayout({ ...props }) {
  return (
    <OpeningProvider>
      <OpeningLayoutContent {...props} />
    </OpeningProvider>
  );
}
function OpeningLayoutContent(props) {

  const {
    opening,
    openingId,
    isLoading,
  } = useOpening();

  if (isLoading) {
    return <Loader />;
  }

  return (
    <div className="flex-1 relative min-w-0">
      <div className="flex flex-1 relative min-w-0">
        <SidebarProvider
          className="w-fit overflow-hidden max-h-dvh"
          name="opening"
        >
          <Sidebar
            collapsible="icon"
            {...props}
            className="sidebar-height border-r left-auto inset-y-auto top-0 mt-16"
          >
            <SidebarHeader className="p-0">
              <div className="p-4">
                <div className="font-semibold">{opening?.title}</div>
              </div>
            </SidebarHeader>
            <SidebarContent>
              <SidebarGroup>
                <SidebarMenu>

                  <NavItem
                    title="Dashboard"
                    icon={DASHBOARD}
                    url={`/apps/openings/${openingId}`}
                    matchExact={true}
                  />

                  <NavItem
                    title="Applicants"
                    icon={USERS}
                    url={`/apps/openings/${openingId}/applicants`}
                  />

                  <NavItemWithBadge
                    title="Interviews"
                    icon={MILESTONE}
                    url={`/apps/openings/${openingId}/interviews`}
                  />

                </SidebarMenu>
              </SidebarGroup>
            </SidebarContent>
            <SidebarRail />
          </Sidebar>
        </SidebarProvider>
        <div className="flex-1 overflow-auto min-w-0">
          <Outlet />
        </div>
      </div>
    </div>
  );
}
